const symbolPattern = /(\d)/gmi;

export default (value) => (value.replace(symbolPattern, '*'));
